import { SearchType, TemplatingContextType } from '@tyro/api';

export function getTemplateContextSearch(
  templatingContext: TemplatingContextType,
) {
  switch (templatingContext) {
    case TemplatingContextType.Contact:
      return {
        includeSearchType: [
          SearchType.Contact,
          SearchType.ContactsOfStudent,
          SearchType.GeneralGroup,
          SearchType.SubjectGroup,
          SearchType.YearGroupEnrollment,
          SearchType.CustomGroup,
        ],
      };
    case TemplatingContextType.Staff:
      return {
        includeSearchType: [
          SearchType.Staff,
          SearchType.GeneralGroup,
          SearchType.SubjectGroup,
          SearchType.YearGroupEnrollment,
          SearchType.CustomGroup,
        ],
      };
    case TemplatingContextType.Person:
      return {
        includeSearchType: [
          SearchType.Student,
          SearchType.Contact,
          SearchType.Staff,
          SearchType.GeneralGroup,
          SearchType.SubjectGroup,
          SearchType.YearGroupEnrollment,
          SearchType.CustomGroup,
        ],
      };
    default:
      return {
        includeSearchType: [
          SearchType.Student,
          SearchType.GeneralGroup,
          SearchType.SubjectGroup,
          SearchType.YearGroupEnrollment,
          SearchType.CustomGroup,
        ],
      };
  }
}
